import { shallowEqual } from "react-redux";
import React from "react";
import { type UscDispatchType, useUscSelector } from "../../../../../../redux/store";
import { showModal } from "../../../../../../../../common-deprecated/redux/actions/ModalActions";
import { UscLabel } from "../../../../../../utils/labels";
import MeasureItem from "../common/MeasureItem";
import type { SpecsSectionPropsType } from "../Specifications";
import Text from "../../../../../../../shared-components/toyota/styles/atoms/Text";
import List from "../../../../styles/atoms/List";
import Button from "../../../../../../../shared-components/toyota/styles/atoms/Button";
import Icon from "../../../../../../../shared-components/toyota/styles/atoms/Icon";
import { tyreInfoUscLabelSelector } from "../../../../../../utils/pdpUtils";
import * as SpecItemStyles from "../common/SpecItem.styles";
import Spacer from "../../../../../../../shared-components/toyota/styles/utils/Spacer.styles";
import { useDispatch } from "../../../../../../../../shared-logic/redux/store";
import { MODAL_TYRE_INFO } from "../../../../../../../../shared-logic/utils/tyreInfoContants";

const SectionTyreInfo = ({ product, cultureName, title, specs }: SpecsSectionPropsType): JSX.Element | null => {
    const dispatch = useDispatch<UscDispatchType>();
    const tyreInfoLabels = useUscSelector(tyreInfoUscLabelSelector, shallowEqual);
    const { tyreSpecs } = product;

    const modalClick = (): void => {
        dispatch(
            showModal({
                type: MODAL_TYRE_INFO,
                tyres: tyreSpecs?.tyres.map((tyre) => tyre.eprel) || [],
                tyreInfoLabels,
            }),
        );
    };

    return (
        <div>
            <Text tag="h4" variant="h6" spacing={{ mb: "spacing-1" }}>
                {title}
            </Text>
            <Spacer spacing={{ mb: "spacing-1" }}>
                <List variant="specs">
                    {!!tyreSpecs?.tyres && tyreSpecs?.tyres.length > 0 ? (
                        specs.tyreInfo && (
                            <li>
                                <Button variant="icon-text" size="small" onClick={modalClick}>
                                    {specs.tyreInfo.title}
                                    <Icon variant="info" />
                                </Button>
                            </li>
                        )
                    ) : (
                        <li>
                            <Text tag="span" variant="body-book" color="grey-7">
                                <UscLabel label="uscPdpTyreInfoNoEprelFallback" />
                            </Text>
                        </li>
                    )}
                </List>
            </Spacer>
            <List variant="specs" tag="dl">
                {!!tyreSpecs?.minimumEfficiencyClass && specs.tyreInfoMinEfficiencyClass && (
                    <SpecItemStyles.SpecItem>
                        <Text tag="dt" variant="body-book" color="grey-7">
                            {specs.tyreInfoMinEfficiencyClass.title}
                        </Text>
                        <Text tag="dd" variant="body-book">
                            {tyreSpecs?.minimumEfficiencyClass}
                        </Text>
                    </SpecItemStyles.SpecItem>
                )}
                {!!tyreSpecs?.minimumWetGripClass && specs.tyreInfoMinWetGripClass && (
                    <SpecItemStyles.SpecItem>
                        <Text tag="dt" variant="body-small-book" color="grey-7">
                            {specs.tyreInfoMinWetGripClass.title}
                        </Text>
                        <Text tag="dd" variant="body-small-book">
                            {tyreSpecs?.minimumWetGripClass}
                        </Text>
                    </SpecItemStyles.SpecItem>
                )}
                {!!tyreSpecs?.minimumNoise && specs.tyreInfoMinRollingNoise && (
                    <MeasureItem
                        title={specs.tyreInfoMinRollingNoise.title}
                        measure={tyreSpecs?.minimumNoise}
                        cultureName={cultureName}
                    />
                )}
            </List>
        </div>
    );
};

export default SectionTyreInfo;
